import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
// The installed @mui/icons-material has no "X" glyph — the bird is the closest brand icon.
import TwitterIcon from "@mui/icons-material/Twitter";

// One config for every platform a plan list can be created for, so the create-list
// drawer, the add-influencers drawer and the table can't drift apart (each used to
// hardcode its own instagram/youtube ternaries). Keep `key` in sync with PLAN_PLATFORMS
// in pluginbackendnode/models/plan.js.
export const PLAN_PLATFORMS = Object.freeze([
  {
    key: "instagram",
    label: "Instagram",
    Icon: InstagramIcon,
    color: "#E1306C",
    followersLabel: "Followers",
    placeholder:
      "Enter Instagram profiles in any of these formats (separate with commas).\n-Full link: `https://www.instagram.com/johndoe`\n-Handle: `johndoe` or `@johndoe`",
  },
  {
    key: "youtube",
    label: "YouTube",
    Icon: YouTubeIcon,
    color: "#FF0000",
    followersLabel: "Subscribers",
    placeholder:
      "Enter YouTube channels in any of these formats (separate with commas).\n-Full link: `https://www.youtube.com/@johndoe`\n-Handle: `johndoe` or `@johndoe`",
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    Icon: LinkedInIcon,
    color: "#0A66C2",
    followersLabel: "Followers",
    placeholder:
      "Enter LinkedIn profiles or company pages (separate with commas).\n-Person: `https://www.linkedin.com/in/johndoe`\n-Company: `https://www.linkedin.com/company/acme`",
  },
  {
    key: "twitter",
    label: "X",
    Icon: TwitterIcon,
    color: "#000000",
    followersLabel: "Followers",
    placeholder:
      "Enter X profiles in any of these formats (separate with commas).\n-Full link: `https://x.com/johndoe`\n-Handle: `johndoe` or `@johndoe`",
  },
]);

const BY_KEY = Object.fromEntries(PLAN_PLATFORMS.map((p) => [p.key, p]));

export const getPlatform = (key) => BY_KEY[key];

// "Linkedin"/"Twitter" is what a plain capitalize() would print — use the real name.
export const platformLabel = (key) =>
  BY_KEY[key]?.label ?? (key ? key.charAt(0).toUpperCase() + key.slice(1) : key);
